<template>
    <div class="home-center-nav">
        <van-tabs v-model="active" scrollspy sticky v-if="this.$store.state.maleActive">
            <!-- 最热榜、好评榜、热搜榜、潜力榜、留存榜、完结榜、VIP榜 -->
            <van-tab title="极品神作" v-if="theHottestListPart">
                <div class="search-title">
                    <h3>极品神作</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in theHottestListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="人气好书" v-if="thePraiseListPart">
                <div class="search-title">
                    <h3>人气好书</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in thePraiseListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="热门搜索" v-if="theMostSearchedPart">
                <div class="search-title">
                    <h3>热门搜索</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in theMostSearchedPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="口碑好评" v-if="thePotentialListPart">
                <div class="search-title">
                    <h3>口碑好评</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in thePotentialListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="高能剧情" v-if="theKeepListPart">
                <div class="search-title">
                    <h3>高能剧情</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in theKeepListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="小众佳作" v-if="theEndListPart">
                <div class="search-title">
                    <h3>小众佳作</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in theEndListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="VIP区" v-if="theViptListPart">
                <div class="search-title">
                    <h3>VIP区</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list rankvip">
                    <li v-for="(item, index) in theViptListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
        </van-tabs>
        <van-tabs v-model="active" scrollspy sticky v-else>
            <!-- 最热榜、好评榜、热搜榜、潜力榜、留存榜、完结榜、VIP榜 -->
            <van-tab title="极品神作" v-if="femaletheHottestListPart">
                <div class="search-title">
                    <h3>极品神作</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femaletheHottestListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="人气好书" v-if="femalethePraiseListPart">
                <div class="search-title">
                    <h3>人气好书</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femalethePraiseListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="热门搜索" v-if="femaletheMostSearchedPart">
                <div class="search-title">
                    <h3>热门搜索</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femaletheMostSearchedPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="口碑好评" v-if="femalethePotentialListPart">
                <div class="search-title">
                    <h3>口碑好评</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femalethePotentialListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="高能剧情" v-if="femaletheKeepListPart">
                <div class="search-title">
                    <h3>高能剧情</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femaletheKeepListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="小众佳作" v-if="femaletheEndListPart">
                <div class="search-title">
                    <h3>小众佳作</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list">
                    <li v-for="(item, index) in femaletheEndListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
            <van-tab title="VIP区" v-if="femaletheViptListPart">
                <div class="search-title">
                    <h3>VIP区</h3>
                    <div class="more" @click="getMore">
                        <span>更多</span><span><van-icon name="arrow"/></span>
                    </div>
                </div>
                <ul class="rank-list rankvip">
                    <li v-for="(item, index) in femaletheViptListPart" :key="index" class="home-cards" @click="getBookId(item._id)">
                        <div class="thumd">
                            <img :src="getImgCover(item.cover)" alt="" />
                            <h5>{{ item.title }}</h5>
                        </div>
                        <div class="book-detail">
                            <h5>{{ item.title }}</h5>
                            <p>{{ item.shortIntro }}</p>
                            <div class="span-detail">
                                <span class="book-author"><van-icon name="user-o" />{{ item.author }} | {{ item.minorCate }}</span>

                                <span class="book-latelyfollower">{{ getLatelyFollower(item.latelyFollower) }}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: 0,
            male: true,
            female: false,
            maleRankCategroysList: null,
            theHottestList: null,
            thePraiseList: null,
            theMostSearched: null,
            thePotentialList: null,
            theKeepList: null,
            theEndList: null,
            theViptList: null,

            theHottestListPart: null,
            thePraiseListPart: null,
            theMostSearchedPart: null,
            thePotentialListPart: null,
            theKeepListPart: null,
            theEndListPart: null,
            theViptListPart: null,

            femaleRankCategroysList: null,
            femaletheHottestList: null,
            femalethePraiseList: null,
            femaletheMostSearched: null,
            femalethePotentialList: null,
            femaletheKeepList: null,
            femaletheEndList: null,
            femaletheViptList: null,

            femaletheHottestListPart: null,
            femalethePraiseListPart: null,
            femaletheMostSearchedPart: null,
            femalethePotentialListPart: null,
            femaletheKeepListPart: null,
            femaletheEndListPart: null,
            femaletheViptListPart: null
        };
    },
    methods: {
        getBookId(id) {
            window.console.log(id, "xxx");
            this.$router.push({
                path: "singlebookdetail",
                query: {
                    id: id
                }
            });
            this.$store.commit("setBookDetailId", {
                value: id
            });
        },
        getImgCover(url) {
            return "https://statics.zhuishushenqi.com" + url;
        },
        getMore() {},
        getLatelyFollower(num) {
            if (num > 10000) {
                let n = num / 10000;
                return n.toFixed(1) + "万人气";
            } else {
                return num + "人气";
            }
        },

        //     let SongCardItems = localStorage.getItem("SongCardItems");
        //     if (SongCardItems && Date.now() < JSON.parse(SongCardItems).time + 60 * 60 * 1000) {
        //         this.SongCardItems = JSON.parse(SongCardItems).data;
        //     } else {
        //         this.axios.get("http://musicapi.leanapp.cn/personalized?limit=6").then(response => {
        //             ({ result: this.SongCardItems } = response.data);
        //             localStorage.setItem(
        //                 "SongCardItems",
        //                 JSON.stringify({
        //                     time: Date.now(),
        //                     data: this.SongCardItems
        //                 })
        //             );
        //         });
        //     }
        //设置本地缓存
        getRankCategoryDetail(rankId, rankList) {
            // let rankList = localStorage.getItem("rankList");
            // window.console.log(rankList);
            // if (localStorage.getItem(rankList)) {
            //     this.rankList = JSON.parse(rankList).data;
            // }else {
            this.axios.get("https://novel.kele8.cn/rank/" + rankId).then(response => {
                this.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });

                // window.console.log(response.data.ranking.books);
                // 男生
                if (rankList == "theHottestList") {
                    ({ books: this.theHottestList } = response.data.ranking);
                    localStorage.setItem(
                        "theHottestList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.theHottestList
                        })
                    );
                    this.theHottestListPart = this.theHottestList.slice(0, 5);
                }
                if (rankList == "thePraiseList") {
                    ({ books: this.thePraiseList } = response.data.ranking);
                    localStorage.setItem(
                        "thePraiseList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.thePraiseList
                        })
                    );
                    this.thePraiseListPart = this.thePraiseList.slice(0, 5);
                }
                if (rankList == "theMostSearched") {
                    ({ books: this.theMostSearched } = response.data.ranking);
                    localStorage.setItem(
                        "theMostSearched",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.theMostSearched
                        })
                    );
                    this.theMostSearchedPart = this.theMostSearched.slice(0, 5);
                }
                if (rankList == "thePotentialList") {
                    ({ books: this.thePotentialList } = response.data.ranking);
                    localStorage.setItem(
                        "thePotentialList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.thePotentialList
                        })
                    );
                    this.thePotentialListPart = this.thePotentialList.slice(0, 5);
                }
                if (rankList == "theKeepList") {
                    ({ books: this.theKeepList } = response.data.ranking);
                    localStorage.setItem(
                        "theKeepList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.theKeepList
                        })
                    );
                    this.theKeepListPart = this.theKeepList.slice(0, 5);
                }
                if (rankList == "theEndList") {
                    ({ books: this.theEndList } = response.data.ranking);
                    localStorage.setItem(
                        "theEndList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.theEndList
                        })
                    );
                    this.theEndListPart = this.theEndList.slice(0, 5);
                }
                if (rankList == "theViptList") {
                    ({ books: this.theViptList } = response.data.ranking);
                    localStorage.setItem(
                        "theViptList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.theViptList
                        })
                    );
                    this.theViptListPart = this.theViptList.slice(0, 5);
                }
                // 女生
                if (rankList == "femaletheHottestList") {
                    ({ books: this.femaletheHottestList } = response.data.ranking);
                    localStorage.setItem(
                        "femaletheHottestList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femaletheHottestList
                        })
                    );
                    this.femaletheHottestListPart = this.femaletheHottestList.slice(0, 5);
                }
                if (rankList == "femalethePraiseList") {
                    ({ books: this.femalethePraiseList } = response.data.ranking);
                    localStorage.setItem(
                        "femalethePraiseList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femalethePraiseList
                        })
                    );
                    this.femalethePraiseListPart = this.femalethePraiseList.slice(0, 5);
                }
                if (rankList == "femaletheMostSearched") {
                    ({ books: this.femaletheMostSearched } = response.data.ranking);
                    localStorage.setItem(
                        "femaletheMostSearched",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femaletheMostSearched
                        })
                    );
                    this.femaletheMostSearchedPart = this.femaletheMostSearched.slice(0, 5);
                }
                if (rankList == "femalethePotentialList") {
                    ({ books: this.femalethePotentialList } = response.data.ranking);
                    localStorage.setItem(
                        "femalethePotentialList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femalethePotentialList
                        })
                    );
                    this.femalethePotentialListPart = this.femalethePotentialList.slice(0, 5);
                }
                if (rankList == "femaletheKeepList") {
                    ({ books: this.femaletheKeepList } = response.data.ranking);
                    localStorage.setItem(
                        "femaletheKeepList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femaletheKeepList
                        })
                    );
                    this.femaletheKeepListPart = this.femaletheKeepList.slice(0, 5);
                }
                if (rankList == "femaletheEndList") {
                    ({ books: this.femaletheEndList } = response.data.ranking);
                    localStorage.setItem(
                        "femaletheEndList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femaletheEndList
                        })
                    );
                    this.femaletheEndListPart = this.femaletheEndList.slice(0, 5);
                }
                if (rankList == "femaletheViptList") {
                    ({ books: this.theViptList } = response.data.ranking);
                    localStorage.setItem(
                        "femaletheViptList",
                        JSON.stringify({
                            time: Date.now(),
                            data: this.femaletheViptList
                        })
                    );
                    this.femaletheViptListPart = this.femaletheViptList.slice(0, 5);
                }
            });
        }
    },
    created() {
        this.getRankCategoryDetail("54d42d92321052167dfb75e3", "theHottestList");
        this.getRankCategoryDetail("5a6844aafc84c2b8efaa6b6e", "thePraiseList");
        this.getRankCategoryDetail("5a6844f8fc84c2b8efaa8bc5", "theMostSearched");
        this.getRankCategoryDetail("54d42e72d9de23382e6877fb", "thePotentialList");
        this.getRankCategoryDetail("564547c694f1c6a144ec979b", "theKeepList");
        this.getRankCategoryDetail("564eb878efe5b8e745508fde", "theEndList");
        this.getRankCategoryDetail("57eb86f0ef9e5a8f20543d7d", "theViptList");

        this.getRankCategoryDetail("54d43437d47d13ff21cad58b", "femaletheHottestList");
        this.getRankCategoryDetail("5a684551fc84c2b8efaab179", "femalethePraiseList");
        this.getRankCategoryDetail("5a684515fc84c2b8efaa9875", "femaletheMostSearched");
        this.getRankCategoryDetail("54d43709fd6ec9ae04184aa5", "femalethePotentialList");
        this.getRankCategoryDetail("5645482405b052fe70aeb1b5", "femaletheKeepList");
        this.getRankCategoryDetail("564eb8a9cf77e9b25056162d", "femaletheEndList");
        this.getRankCategoryDetail("57eb959df60eb7e21fb3a8b7", "femaletheViptList");
    }
};
</script>

<style lang="less" scope>
.home-center-nav {
    margin-bottom: 50px;
    .van-tabs {
        .van-tab {
            font-size: 15px;
            font-weight: 500;
        }
        .van-tabs__content {
            .search-title {
                padding: 0 10px;
                &::after {
                    content: "";
                    display: block;
                    clear: both;
                }
                h3 {
                    display: inline-block;
                    font-size: 16px;
                }
                .more {
                    line-height: 60px;
                    float: right;
                    font-size: 12px;
                    .van-icon {
                        top: 1px;
                    }
                }
            }
            ul.rank-list {
                padding: 0 10px 50px;
                border-bottom: 10px solid rgb(245, 244, 244);
                &.rankvip {
                    margin: 0 0 80px;
                    border-bottom: none;
                }
                &::after {
                    content: "";
                    clear: both;
                    display: block;
                }
                li.home-cards {
                    &:nth-child(n + 2) {
                        padding: 0 10px;
                        .thumd {
                            float: left;
                            position: relative;
                            img {
                                width: 75px;
                                height: 100px;
                                margin-right: 8px;
                            }
                            h5 {
                                font-size: 12px;
                                color: #999;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 1;
                                overflow: hidden;
                                position: absolute;
                                top: 85%;
                                left: 0;
                            }
                        }

                        .book-detail {
                            display: none;
                        }
                    }
                    padding: 0 0 15px 15px;
                    margin-bottom: 15px;
                    // border-bottom: 1px solid rgb(231, 231, 231);
                    .thumd {
                        img {
                            float: left;
                            width: 75px;
                            height: 100px;
                            margin-right: 15px;
                            border-radius: 2px;
                            box-shadow: 0 2px 1px 2px rgba(0, 0, 0, 0.15);
                        }
                        h5 {
                            display: none;
                        }
                    }

                    .book-detail {
                        h5 {
                            font-size: 14px;
                            margin: 5px 0;
                        }
                        p {
                            color: #999;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            overflow: hidden;
                            font-size: 10px;
                            margin: 5px 0;
                        }
                        .span-detail {
                            span {
                                color: #999;
                                font-size: 10px;
                                margin-top: 10px;
                                transform: scale(0.6);
                                padding: 1px 3px;
                                border-radius: 10px;
                                &.book-author {
                                }

                                &.book-latelyfollower {
                                    float: right;
                                    transform: scale(0.9);
                                    padding: 1px 3px;
                                    background: rgb(245, 170, 170);
                                    color: red;
                                    border-radius: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
